import {useState} from 'react'
import {v4 as uuidv4} from 'uuid'
import NoteItem from '../NoteItem'
import {
  NotesContainer,
  Heading,
  Form,
  Input,
  Textarea,
  AddBtn,
  NoNotesContainer,
  NoNotesImage,
  NoNotesHeading,
  NoNotesPara,
  NotesListContainer,
} from './styledComponents'

const Notes = () => {
  const [title, setTitle] = useState('')
  const [notes, setNotes] = useState('')
  const [notesList, setNotesList] = useState([])

  const renderNotes = () => {
    if (notesList.length === 0) {
      return (
        <NoNotesContainer>
          <NoNotesImage
            alt="notes empty"
            src="https://assets.ccbp.in/frontend/hooks/empty-notes-img.png"
          />
          <NoNotesHeading>No Notes Yet</NoNotesHeading>
          <NoNotesPara>Notes you add will appear here</NoNotesPara>
        </NoNotesContainer>
      )
    }

    return (
      <NotesListContainer>
        {notesList.map(item => (
          <NoteItem key={item.id} noteItem={item} />
        ))}
      </NotesListContainer>
    )
  }

  const onChangeTitle = event => {
    setTitle(event.target.value)
  }

  const onChangeNotes = event => {
    setNotes(event.target.value)
  }

  const submitForm = event => {
    event.preventDefault()
    const noteItem = {
      id: uuidv4(),
      title,
      notes,
    }
    setNotesList(prevNotesList => [...prevNotesList, noteItem])
    setTitle('')
    setNotes('')
  }

  return (
    <NotesContainer>
      <Heading>Notes</Heading>
      <Form onSubmit={submitForm}>
        <Input
          type="text"
          onChange={onChangeTitle}
          value={title}
          placeholder="Title"
        />
        <Textarea
          onChange={onChangeNotes}
          value={notes}
          placeholder="Take a Note..."
          cols="70"
          rows="5"
        />
        <AddBtn type="submit">Add</AddBtn>
      </Form>
      {renderNotes()}
    </NotesContainer>
  )
}
export default Notes
